<template>
  <div class="container-search-inventory">
    <img src="@/assets/icons/ic_search.svg" alt="" />
    <input
      type="text"
      placeholder="검색...(와인아이디 숫자, 이름, 지역)"
      v-model="searchValue"
      @keyup.enter="search"
    />
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      searchValue: ""
    };
  },
  methods: {
    search() {
      this.$events.fire("filter-set", this.searchValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.container-search-inventory {
  position: relative;
  margin-bottom: 20px;

  input:focus {
    outline: none;
  }

  input {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    width: 300px;
    font-size: 16px;
    padding: 8px 8px 8px 40px;
  }

  img {
    position: absolute;
    height: 18px;
    transform: translate(8px, 12px);
    opacity: 0.2;
  }
}

@media screen and (max-width: 1024px) {
  .container-search-inventory {
    margin-top: 0;
    margin-bottom: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/search/SearchBar.vue